import React from 'react'

export function GenericCardIcon({width = 30}) {
  return (
    <svg
      preserveAspectRatio="xMinYMid meet"
      viewBox="0 0 48 30"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      style={{width: `${width}px`, height: 'auto', display: 'block'}}
    >
      <defs>
        <rect id="path-1" x="0" y="0" width="48" height="30" rx="3" />
      </defs>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <use fill="#FFFFFF" fillRule="evenodd" xlinkHref="#path-1" />
              <rect
                stroke="#C5C5C8"
                strokeWidth="1"
                x="0.5"
                y="0.5"
                width="47"
                height="29"
                rx="3"
              />
            </g>
            <g opacity="0.5" transform="translate(7.000000, 7.000000)">
              <path
                d="M6.8801,15 L0.3851,15"
                stroke="#8C8C91"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M13.5867,15 L9.6577,15"
                stroke="#8C8C91"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M23.5182444,15 L16.6577,15"
                stroke="#8C8C91"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M30.5867,15 L26.6577,15"
                stroke="#8C8C91"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M30.5041505,11 L0.3851,11"
                stroke="#8C8C91"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M5.5676,3.0588 C5.5676,4.4908 4.4076,5.6508 2.9766,5.6508 C1.5456,5.6508 0.3846,4.4908 0.3846,3.0588 C0.3846,1.6278 1.5456,0.4678 2.9766,0.4678 C4.4076,0.4678 5.5676,1.6278 5.5676,3.0588"
                fill="#C4C4C7"
              />
              <path
                d="M5.56300011,3.0588 C5.56300011,4.4908 4.40300011,5.6508 2.97200011,5.6508 C1.54100011,5.6508 0.380000114,4.4908 0.380000114,3.0588 C0.380000114,1.6278 1.54100011,0.4678 2.97200011,0.4678 C4.40300011,0.4678 5.56300011,1.6278 5.56300011,3.0588 Z"
                stroke="#8C8C91"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M9.7141,3.0588 C9.7141,4.4908 8.5541,5.6508 7.1231,5.6508 C5.6921,5.6508 4.5311,4.4908 4.5311,3.0588 C4.5311,1.6278 5.6921,0.4678 7.1231,0.4678 C8.5541,0.4678 9.7141,1.6278 9.7141,3.0588"
                fill="#FEFEFE"
              />
              <path
                d="M9.7141,3.0588 C9.7141,4.4908 8.5541,5.6508 7.1231,5.6508 C5.6921,5.6508 4.5311,4.4908 4.5311,3.0588 C4.5311,1.6278 5.6921,0.4678 7.1231,0.4678 C8.5541,0.4678 9.7141,1.6278 9.7141,3.0588 Z"
                stroke="#8C8C91"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}
